var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEgg = function SvgIconEgg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.949 2.492C9.876 1.77 10.934 1.25 12 1.25s2.124.52 3.051 1.242c.947.736 1.86 1.76 2.656 2.953 1.587 2.38 2.793 5.57 2.793 8.805a8.5 8.5 0 1 1-17 0c0-3.234 1.206-6.424 2.793-8.805.796-1.193 1.71-2.217 2.656-2.953m-.992 4.063C6.544 8.675 5.5 11.485 5.5 14.25a6.5 6.5 0 0 0 13 0c0-2.766-1.044-5.576-2.457-7.695-.704-1.057-1.478-1.908-2.22-2.484-.76-.591-1.389-.821-1.823-.821s-1.064.23-1.824.82c-.74.577-1.515 1.428-2.219 2.485",
    clipRule: "evenodd"
  })));
};
export default SvgIconEgg;